import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

interface GenerateParams {
  conversationId: string
  tone?: string
  instruction?: string
}

interface GenerateResponse {
  suggestions: string[]
}

const generateMessage = async (params: GenerateParams): Promise<GenerateResponse> => {
  const { data } = await api.post<GenerateResponse>('/ft_conversation-ai/generate', params)
  return data
}

export const useFtConversationAiGenerate = () => {
  return useMutation<GenerateResponse, Error, GenerateParams>({
    mutationFn: generateMessage,
  })
}
